import { render, staticRenderFns } from "./AcknowledgmentManagement.vue?vue&type=template&id=6403e820"
import script from "./AcknowledgmentManagement.vue?vue&type=script&lang=js"
export * from "./AcknowledgmentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports